import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { PARTS } from "@/data/book";
import { priceCta } from "@/config/site";
import { CtaButton } from "./CtaButton";
import { Reveal } from "./Reveal";

export const Contents = () => (
  <section id="obsah" className="bg-cream py-28 text-navy-deep sm:py-36" data-testid="contents-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <p className="mb-6 flex items-center gap-4 text-xs font-semibold uppercase tracking-[0.3em] text-bronze">
          <span className="h-px w-10 bg-bronze/60" aria-hidden="true" />
          Obsah knihy
        </p>
      </Reveal>
      <div className="flex flex-col justify-between gap-8 lg:flex-row lg:items-end">
        <Reveal delay={0.1}>
          <h2 className="font-serif text-4xl font-medium leading-[1.08] tracking-tight sm:text-5xl lg:text-6xl">
            40 principů.
            <br />
            <span className="italic text-bronze">5 oblastí života.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="max-w-md text-base leading-relaxed text-navy-deep/60 sm:text-lg">
            Od práce na sobě přes seznamování a vztahy až po charakter. Rozbal jednotlivé části
            a projdi si všech 40 principů.
          </p>
        </Reveal>
      </div>

      <Reveal delay={0.15} className="mt-16">
        <Accordion type="single" collapsible className="border-t border-navy-deep/10">
          {PARTS.map((part, idx) => (
            <AccordionItem key={part.numeral} value={part.numeral} className="border-navy-deep/10">
              <AccordionTrigger
                data-testid={`part-${idx + 1}-trigger`}
                className="group py-8 text-left hover:no-underline"
              >
                <div className="flex w-full flex-col gap-2 pr-6 sm:flex-row sm:items-baseline sm:gap-8">
                  <span className="shrink-0 text-xs font-semibold uppercase tracking-[0.25em] text-bronze">
                    Část {part.numeral}
                  </span>
                  <span className="font-serif text-2xl font-medium uppercase leading-tight tracking-wide text-navy-deep transition-colors group-hover:text-bronze sm:text-3xl">
                    {part.title}
                  </span>
                  <span className="text-sm text-navy-deep/50 sm:ml-auto">{part.range}</span>
                </div>
              </AccordionTrigger>
              <AccordionContent data-testid={`part-${idx + 1}-content`} className="pb-10">
                <p className="max-w-2xl text-base leading-relaxed text-navy-deep/70">
                  {part.description}
                </p>
                <ol className="mt-8 grid grid-cols-1 gap-x-12 gap-y-3 md:grid-cols-2">
                  {part.principles.map((title, i) => {
                    const num = idx * 8 + i + 1;
                    return (
                      <li key={title} className="flex items-baseline gap-4 border-b border-navy-deep/[0.06] pb-3">
                        <span className="font-serif text-sm italic text-bronze/70">
                          {String(num).padStart(2, "0")}
                        </span>
                        <span className="text-[15px] leading-relaxed text-navy-deep/85">{title}</span>
                      </li>
                    );
                  })}
                </ol>
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>

      <Reveal delay={0.2} className="mt-14 text-center">
        <CtaButton event="contents_cta" location="contents" size="lg" testId="contents-cta">
          {priceCta}
        </CtaButton>
      </Reveal>
    </div>
  </section>
);
